const  utmSourceField = document.querySelector('#mainContent form [name$="[utm_source]"]') as HTMLInputElement | null;
const  utmCampaignField = document.querySelector('#mainContent form [name$="[utm_campaign]"]') as HTMLInputElement | null;

if (utmSourceField && utmCampaignField)      {
    let utmSource = null;
    let utmCampaign = null;

    const queryParams = Object.entries(new URLSearchParams(window.location.search));
    if (queryParams.length > 0) {
        for (const [key, value] of queryParams) {
            if (key === "utm_source") {
                utmSource = value;
            }
            if (key === "utm_campaign") {
                utmCampaign = value;
            }
        }
    } else {
        if (window.localStorage.getItem("utm_source") !== null) {
            // @ts-ignore
            utmSource = window.localStorage.getItem("utm_source");
        }
        if (window.localStorage.getItem("utm_campaign") !== null) {
            // @ts-ignore
            utmCampaign = window.localStorage.getItem("utm_campaign");
        }
    }

    if (utmSource !== null &&  utmSourceField !== null) {
        utmSourceField.value =  utmSource;
    }

    if (utmCampaign !== null &&  utmCampaignField !== null) {
        utmCampaignField.value =  utmCampaign;
    }
}
